// src/components/ThemeSync.tsx
//
// The backend (user_settings.theme) is the source of truth for a logged-in
// user's theme across devices/tabs/sessions. next-themes/localStorage is
// just the local live-rendering mechanism. On login/app load, hydrate
// next-themes from the backend value once per session so a fresh browser
// or device picks up the saved preference instead of defaulting to
// "system". Subsequent theme changes are pushed to the backend directly by
// the controls that make them (ThemeToggle, SettingsModal).

import { useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { useTheme } from "next-themes";
import { getUserSettings } from "@/api/client";

export function ThemeSync() {
  const { setTheme } = useTheme();
  const isLoggedIn = document.cookie.includes("logged_in=true");
  const hydratedRef = useRef(false);

  const { data } = useQuery({
    queryKey: ["userSettings"],
    queryFn: getUserSettings,
    enabled: isLoggedIn,
    staleTime: Infinity,
  });

  useEffect(() => {
    if (hydratedRef.current) return;
    if (!data?.theme) return;
    hydratedRef.current = true;
    setTheme(data.theme);
  }, [data, setTheme]);

  return null;
}
